<template>
  <div class="box annual-usage">
    <details-box-heading label="Annual Usage" />

    <div class="box-content mb-2">
      <details-numeric-input
        field="annual_usage"
        :component="components.annual_usage.annual_usage"
        @change="updateMasterData"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import DetailsPaneBase from './DetailsPaneBase.vue'

@Component({
  name: 'DetailsAnnualUsageBox',
})
export default class DetailsAnnualUsageBox extends DetailsPaneBase {
  get annualUsage() {
    return this.components.annual_usage || {}
  }
}
</script>
